var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('bi.sidebar.shortTitle'),"logo":_vm.$store.getters.systemLogoSidebar,"titleImg":_vm.$store.getters.systemTitleImage,"title":_vm.$store.getters.systemTile}},[(_vm.type == 1)?_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Formulários',
          icon: 'tim-icons icon-notes',
          path: '/module/forms/' + _vm.moduleId,
        }}}),(_vm.$store.getters.isChecklistPendenciesView)?_c('sidebar-item',{ref:"sidebarItemPendencies",attrs:{"link":{
          name: _vm.$t('checklist.sidebar.Pendencies'),
          icon: 'tim-icons icon-alert-circle-exc',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.pendenciesOpened'),
            path: '/module/pendencies/opened/' + _vm.moduleId,
            icon: 'tim-icons icon-alert-circle-exc',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.pendenciesApproved'),
            path: '/module/pendencies/approved/' + _vm.moduleId,
            icon: 'tim-icons icon-alert-circle-exc',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.pendenciesExpired'),
            path: '/module/pendencies/expired/' + _vm.moduleId,
            icon: 'tim-icons icon-alert-circle-exc',
          }}})],1):_vm._e(),_vm._l((_vm.views),function(view){return _c('div',{key:view.id},[(view.formId != null)?_c('sidebar-item',{ref:"sidebarItemForms",refInFor:true,attrs:{"link":{
            name: view.formName,
            icon: 'tim-icons icon-paper',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Preenchidos',
              path: '/modulo/' + _vm.moduleId + '/' + view.id,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Preencher',
              path: '/module/fillForm/' + _vm.moduleId + '/' + view.formId,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Meus rascunhos',
              path: '/module/layout/draft/' + _vm.moduleId + '/' + view.formId,
            }}})],1):_vm._e(),(view.powerBiViewId != null)?_c('sidebar-item',{attrs:{"link":{
            name: view.biName,
            icon: 'tim-icons icon-chart-pie-36',
            path: '/modulo/' + _vm.moduleId + '/' + view.id,
          }}}):_vm._e()],1)})],2):_vm._e(),(_vm.type == 2)?_c('template',{slot:"links"},_vm._l((_vm.views),function(view){return _c('div',{key:view.id},[(view.powerBiViewId != null)?_c('sidebar-item',{attrs:{"link":{
            name: view.biName,
            icon: 'tim-icons icon-chart-pie-36',
            path: '/modulo/' + _vm.moduleId + '/' + view.id,
          }}}):_vm._e()],1)}),0):_vm._e()],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar',{attrs:{"module":"BI"}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }